// extracted by mini-css-extract-plugin
module.exports = {"header":"SubHeaderCOD_header__FYSCW","title":"SubHeaderCOD_title__jJWc_","small":"SubHeaderCOD_small__3uJha","btnContainer":"SubHeaderCOD_btnContainer__32izt"};